import * as types from "@/store/types";
import axios from "axios";
import firebase from "firebase/app";
import "firebase/storage";
import { set } from "lodash";

export default {
  saveToken({ commit }, token) {
    commit(types.SAVE_TOKEN, token);
  },
  async getProfile({ commit }, id) {
    try {
      const { data } = await axios.get(`/api/web/user/${id}/profile`);
      commit(types.FECTH_PROFILE, { profile: data });
      return data;
    } catch (e) {
      return null;
    }
  },
  async getCallerProfile({ commit }, id) {
    try {
      const { data } = await axios.get(`/api/web/user/${id}/caller`);
      commit(types.FECTH_PROFILE, { profile: data });
      return data;
    } catch (e) {
      return null;
    }
  },
  async listProfiles({ commit }) {
    try {
      const { data } = await axios.get(`/api/web/user/profiles/featured`);
      commit(types.FECTH_PROFILES, { profiles: data });
      return data;
    } catch (e) {
      return null;
    }
  },
  async fetchProfiles({ commit }, page = 1) {
    try {
      const { data } = await axios.get(`/api/web/user/profiles/featured?page=${page}`);
      commit(types.FECTH_PROFILES, { profiles: data });
      return data;
    } catch (e) {
      return null;
    }
  },
  async listSearchProfiles({ commit }, payload) {
    try {
      const { data } = await axios.get(
        `/api/web/user/profiles/search?page=${payload.page}&search=${payload.search_user}&filter=${payload.filter}&countries=${payload.countries}&age=${payload.age}`
      );
      commit(types.LIST_SEARCH_USERS, { profiles: data });
      return data;
    } catch (e) {
      return e
    }
  },
  async sendSmile({ commit }, id) {
    try {
      const { data } = await axios.get(`/api/web/user/${id}/greetings`);
      commit(types.SEND_SMILE, { smile: data });
      return data;
    } catch (e) {
      return null;
    }
  },
  async listBlockedProfiles({ commit }, payload) {
    try {
      const { data } = await axios.get(
        `/api/web/blocked-users?page=${payload.page}&search=${payload.search_user}&filter=${payload.filter}`
      );
      commit(types.LIST_BLOCKED, { blocked: data });
      return data;
    } catch (e) {
      return null;
    }
  },
  async sendComplaints({ }, { complaints }) {
    try {
      await axios.post("/api/web/denounces", complaints);
      return true;
    } catch (e) {
      return null;
    }
  },

  async showImages({ commit }, id) {
    try {
      const { data } = await axios.get(`/api/web/user/${id}/pictures`);
      commit(types.SHOW_IMAGES, { photos: data });
      return data;
    } catch (e) {
      return null;
    }
  },

  async uploadImageLimited({ commit }, id) {
    try {
      const { data } = await axios.get(`/api/web/user/${id}/pictures/limited`);
      return data;
    } catch (e) {
      return null;
    }
  },
  async selectProfile({ commit }, item) {
    try {
      const { data } = await axios.put(
        `/api/web/user/pictures/${item.id}/cover`
      );
      // commit(types.SHOW_IMAGES, { photos: data });
      return data;
    } catch (e) {
      return null;
    }
  },

  async changeVisible({ commit }, item) {
    try {
      const { data } = await axios.put(
        `/api/web/user/pictures/${item.id}/visible`
      );
      // commit(types.SHOW_IMAGES, { photos: data });
      return data;
    } catch (e) {
      return e;
    }
  },

  async changeVisibleFav({ commit }, item) {
    try {
      const { data } = await axios.put(
        `/api/web/user/pictures/${item.id}/visible-favorite`
      );
      // commit(types.SHOW_IMAGES, { photos: data });
      return data;
    } catch (e) {
      return e;
    }
  },

  async changeInvisible({ commit }, item) {
    try {
      const { data } = await axios.put(
        `/api/web/user/pictures/${item.id}/not-visible`
      );
      // commit(types.SHOW_IMAGES, { photos: data });
      return data;
    } catch (e) {
      return e;
    }
  },

  async deletePicture({ commit }, item) {
    try {
    const { data } = await axios.delete(`/api/web/user/pictures/${item.id}`);
      const url = item.url;
      var indexA = url.lastIndexOf("%") + 3;
      var indexB = url.lastIndexOf("?");
      var imageUrl = url.substring(indexA, indexB);
      if (imageUrl) {
        await firebase
          .storage()
          .ref(`profile/${imageUrl}`)
          .delete();
      }
      // commit(types.SHOW_IMAGES, { photos: data });
      return data;
    } catch (e) {
      return e;
    }
  },
  async moreFriends({ commit }) {
    try {
      const {
        data: { data }
      } = await axios.get("/api/web/more-friends");
      commit(types.MORE_PROFILES, data);
      return data;
    } catch (e) {
      return null;
    }
  },
  async getSettings({ commit }, user) {
    try {
      const {
        data: [data]
      } = await axios.get(`/api/web/user/${user}/settings`);
      commit(types.SHOW_SETTINGS, { settings: data });
    } catch {
      return null;
    }
  },
  async storeSettings({ commit }, { user, settings }) {
    try {
      const data = await axios.post(`/api/web/user/${user}/settings`, settings);
      return data;
    } catch (e) {
      return null;
    }
  },
  async updateSettings({ commit }, { user, settings }) {
    try {
      const data = await axios.put(`/api/web/user/${user}/settings`, settings);
      return data;
    } catch (e) {
      return null;
    }
  },
  async getSessionId({ commit }, { lang, plan, path, user }) {
    try {
      const { data } = await axios.get(`/api/web/subscriptions/checkout?lang=${ lang }${ plan ? `&plan=${plan}` : '' }${path ? `&path=${path}` : ''}${user ? `&user=${user}`: ''}`);
      return data;
    } catch (e) {
      return null;
    }
  },

  async setSubscription({ commit }, { order }) {
    try {
      const response = await axios.post(`/api/web/subscriptions/paypal/checkout`, { order : order });
      console.log(response);
      return response;
    } catch (e) {
      console.log(e);
      return null;
    }
  },

  async getUpgradeSession({ commit }, { lang, path = null, user = null }) {
    try {
      const { data } = await axios.get(`/api/web/subscriptions/go-premium?lang=${ lang }${path ? `&path=${path}` : ''}${user ? `&user=${user}` : ''}`);
      return data;
    } catch (e) {
      return null;
    }
  },

  appendSeenUser({ state, commit}, user) {

    // Check if a profile is already in the list
    // it has to be at least one profile to make effective this validation
    if (state.seenProfilesLength > 0) {
      let nodeId = -1;
      let currentNode = state.seenProfilesLinkedList;

      while (currentNode){
        nodeId = currentNode.value.id;
        if (nodeId === user.id) {
          break;
        }

        currentNode = currentNode.next;
      }

      if (currentNode) {
        return;
      }
    }

    const newNode = {
      value: user,
      next: null,
      prev: null,
      index: 1
    };

    commit(types.APPEND_SEEN_USER, { node: newNode });
  },

  setPaginationPage({ state, commit }, page) {
    commit(types.SET_CURRENT_PAGE_PAGINATION, { page });
  },

  storeSearchParams({ state, commit }, params) {
    commit(types.STORE_SEARCH_PARAMS, params);
  },

  traverseToUserId({commit}, userId) {
    commit(types.TRAVERSE_TO_ID, { userId });
  }
};
